import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { modifyDatosCierreDiario } from '../../actions/cierre_diario_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions/index';

//components:

import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../components/int_number_input_formatter';
import IntNumberFormatText from '../../components/int_number_text_formatter';

//helpers:
import { getData, postData } from '../../dataLib';

//material ui:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Fade } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';

//grid de datos de contadores de maquinas
//solo trabaja con state local ya que ningun otro control depende de estos datos
//y hace todas las modificaciones directamente en la DB cuando se hace click en OK

const styles = theme => ({
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: 300,
        width: '100%',
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    header: {
        display: 'flex'
    },
    headerBox: {
        width: 85,
        margin: 0,
        fontSize: 12,
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        border: '1px solid #dddddd',
        background: '#f9f9f9',
    },
    table: {
        display: 'inline-block',
        border: '1px solid #dddddd',
    },
    row: {
        display: 'flex',
    },
    rowTextCell: {
        width: 85,
        fontSize: 12,
        textAlign: 'right',
        border: '1px solid #dddddd',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    inputCell: {
        textAlign: 'right',
        fontSize: 12,
        padding: 0
    },
});

class CierreDiarioArcadeGrid extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            lecturas: [],
            total: 0.00,
            showSpinner: true,
        };
    };

    componentDidUpdate(prevProps) {
        if (this.producto === undefined &&
            prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
            this.getLecturas();
        }

        if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro)
            this.setState({ ...this.state, showSpinner: true })
    };

    calculateTotal = (rows) => {
        let total = 0.00;
        rows.forEach((r) => {
            total += parseFloat(r.ingresos);
        });

        return total.toFixed(2);
    };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkValues = (lectura) => {
        if (lectura.contadorIni > lectura.contadorFin) {
            this.messageError('Lectura final debe ser igual o mayor a la inicial');
            return false;
        };
        return true;
    };

    modifyLectura = (lectura) => {
        var rows = this.state.lecturas.map((row) => {
            if (row.id === lectura.id) {
                return { ...row, contadorFin: lectura.contadorFin, ingresos: lectura.contadorFin - lectura.contadorIni, comentario: lectura.comentario };
            }
            else return row;
        });
        this.props.setSaveState(true);
        this.setState({ ...this.state, lecturas: rows, total: this.calculateTotal(rows) });
    };

    //obtiene las lecturas de los contadores
    getLecturas = () => {

        let lecturasURL = 'VLecturas?iTipo=3&date=' + this.props.centroDiaSelected.dia

        if (this.props.producto !== undefined) lecturasURL += '&zona_id=' + this.props.producto.zonaId + '&centro_id=' + this.props.producto.centroId;
        else lecturasURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        getData(lecturasURL,
            (response) => {
                this.setState({ ...this.state, lecturas: response.data, total: this.calculateTotal(response.data), showSpinner: false });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching lecturas'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    };

    //hace un update de lecturas, muestra un mensaje y actualiza el store
    updateLecturas = () => {
        postData('vlecturas/lecturas',
            () => {
                this.props.hideDialog();
                // this.props.openDialog('SimpleMessage', {
                //     message: 'gastos actualizados'
                // }, uuidv4(), false, 'sm');
                this.props.setSaveState(false);
                if (this.props.producto !== undefined) this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: this.state.total })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating arcade'
                }, uuidv4(), false, 'sm');
            },
            this.state.lecturas,
            this.props.user
        );

    };

    componentDidMount = () => {
        this.getLecturas();
    };

    deshacer = () => {
        this.setState({ ...this.state, showSpinner: true })
        this.getLecturas();
    }


    handleGridRowsUpdated = (fromRow, toRow, updated, tipo) => {
        
        for (let i = fromRow; i <= toRow; i++) {

            let updatedRow = update(this.state.lecturas[i], { $merge: updated });
            if(this.checkValues(updatedRow)) this.modifyLectura(updatedRow);
        }

    };

    handleEurosContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.lecturas[index], contadorFin: event.target.value });
    }

    handleEurosContadorBlur = (event, index) => {
        if(this.state.lecturas[index].contadorIni > this.state.lecturas[index].contadorFin){
            this.props.openDialog('SimpleMessage', {message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');    
            this.modifyLectura({ ...this.state.lecturas[index], contadorFin: this.state.lecturas[index].contadorIni });
        }
    }

    renderEurosRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.regInterno}</div>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}>{row.fecha.slice(0,10)}</div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isDiaCerrado}
                        id={"contador-fin-euros-" + index}
                        value={this.state.lecturas[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleEurosContadorChange(event, index)}
                        onBlur={(event) => this.handleEurosContadorBlur(event, index)}
                    />
                </div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.ingresos} /></div>
            </div>
        )
    }

    renderEurosRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>Reg. Int.</div>
                    <span title='Número de contador'><div className={classes.headerBox}>#</div></span>
                    <div className={classes.headerBox}>Fecha</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                    <span title='Ingresos calculados'><div className={classes.headerBox}>Ingresos</div></span>
                </div>
                {this.state.lecturas.map((row, index) => {
                    return this.renderEurosRow(row, index);
                })}
            </div>
        )
    }


    render() {
        const { classes } = this.props;

        return (
            !this.state.showSpinner ?
                <div className={classes.divData}>
                    <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>

                    {this.renderEurosRows()}

                    <div className={classes.total}>
                        <p style={{ margin: 0 }}>Total</p>
                        <Tooltip title="Total ingresos calculados" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{tooltip: this.props.classes.tooltip}}>
                            <TextField
                                id="total"
                                value={this.state.total}
                                disabled
                                variant="outlined"
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                            />
                        </Tooltip>
                    </div>


                    <div>
                        {this.props.isDialog ?
                            <Button variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                            :
                            <Button hidden={this.props.isDiaCerrado} variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.deshacer() }}>Deshacer</Button>
                        }
                        {!this.props.isDiaCerrado ? <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.updateLecturas() }}>Guardar</Button> : ''}
                    </div>
                </div>

                :
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
        );
    };
};


CierreDiarioArcadeGrid.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isDialog: PropTypes.bool,
    isDiaCerrado: PropTypes.bool.isRequired,
    user: PropTypes.object,    
    //dispatch
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //parameters
    producto: PropTypes.object

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyDatosCierreDiario,
        hideDialog,
        openDialog,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioArcadeGrid));